import { useState } from "react";
import { useForm } from "react-hook-form";
import { api } from "@/services/api";
import { useToast } from "@chakra-ui/react";
import { TCarregamento } from "../../@types/carregamento";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

export const mensagemTipo = (
  title: string,
  tipo: 1 | 2 | 3,
  tipoIdentificador?:
    | "string|varchar|palavra"
    | "numerico"
    | "boolean | verdadeiro ou falso"
) => {
  switch (tipo) {
    case 1:
      return `${title} é um identificador necessário`;
    case 2:
      return `${title} recebe o identificador dele.`;
    default:
      return `${title} é do tipo ${tipoIdentificador}`;
  }
};

export const ServicesCarregamento = () => {
  let baseurl = "carregamento";

  const toast = useToast();

  const [isRequestig, setRequestig] = useState<boolean>(false);

  let resolver = zodResolver(
    z.object({
      codigo: z.string().min(1, {
        message: "Código é um identificador que não pode ser vázio",
      }),
      destino: z.string().min(1, { message: mensagemTipo("Destino", 1) }),
      ajudante1: z.string().optional(),
      ajudante2: z.string().optional(),
      ajudante3: z.string().optional(),
      datachegada: z.string().optional(),
      datageracao: z.string().optional(),
      datasaida: z.string().optional(),
      kmfinal: z.string().optional(),
      kminicial: z.string().optional(),
      pedidos: z.any().optional(),
      motorista: z.string().optional(),
      rota: z.number({
        required_error: mensagemTipo("Rota", 1),
        invalid_type_error: mensagemTipo("Rota", 2),
      }),
      veiculo: z.number({
        required_error: mensagemTipo("Veículo", 1),
        invalid_type_error: mensagemTipo("Veículo", 2),
      }),
    })
  );

  const {
    formState: {
      errors,
      defaultValues = {
        notas: [],
      },
    },
    register,
    reset,
    handleSubmit,
    watch,
    setValue,
  } = useForm<TCarregamento>({
    resolver,
  });

  const onSubmit = handleSubmit(async (values) => {
    setRequestig(true);
    try {
      let req = await api.post(baseurl, { ...values, status: 1 });
      let res = req.data;
      toast({
        description: "Criado com sucesso!",
        status: "success",
      });
      reset({
        ajudante1: "",
        ajudante2: "",
        ajudante3: "",
        codigo: "",
        datachegada: "",
        datageracao: "",
        datasaida: "",
        destino: "",
        kmfinal: "",
        kminicial: "",
        motorista: "",
        pedidos: [],
        rota: 0,
        veiculo: 0,
      });
    } catch (error: any) {
      toast({
        description: JSON.stringify(error?.response?.data?.mensagem || "Erro ao realizar operação", null, 2),
        status: "error",
      });
    } finally {
      setRequestig(false);
    }
  });

  return {
    register,
    onSubmit,
    isRequestig,
    defaultValues,
    setValue,
    errors,
    watch,
    reset,
  };
};
